<app-chart type="line" [data]="chartData" [options]="chartOptions" [height]="height"></app-chart>
